import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Changelog } from "../../types/changelog.type";
import { api } from "../../api/api";
import { DatePicker, message, Space, Table, Typography } from "antd";
import dayjs from "dayjs";

const { Title } = Typography;
const { RangePicker } = DatePicker;

export default function Changelogs() {
  const { itemId, type, name } = useParams();
  const [changelogs, setChangelogs] = useState<Changelog[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [page, setPage] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(10);
  const [total, setTotal] = useState<number>(0);
  const [dateRange, setDateRange] = useState<
    [dayjs.Dayjs, dayjs.Dayjs] | undefined
  >([dayjs().startOf("month"), dayjs().endOf("month")]);

  const handleRangeChange = (dates: any) => {
    if (dates) {
      setDateRange([dates[0], dates[1]]);
    } else {
      setDateRange(undefined);
    }
  };

  const fetchChangelogs = async () => {
    setLoading(true);
    try {
      const response = await api.get(`/${type}/${itemId}/change-logs`, {
        params: {
          page,
          limit: pageSize,
          startDate: dateRange ? dateRange[0]?.format("DD.MM.YY") : undefined,
          endDate: dateRange ? dateRange[1]?.format("DD.MM.YY") : undefined,
        },
      });

      setChangelogs(response.data.changelogs);
      setTotal(response.data.total);
    } catch (error) {
      console.log(error);
      message.error("Ошибка получение журнала изменнеий.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchChangelogs();
  }, [page, pageSize, dateRange]);

  const columns = [
    {
      title: "Дата",
      dataIndex: "date",
      key: "date",
    },
    {
      title: "Обновил",
      dataIndex: "username",
      key: "username",
    },
    {
      title: "Материалы",
      key: "materials",
      render: (_: any, record: Changelog) => (
        <ul>
          {record.materials.map((material) => (
            <li key={material.materialId}>
              {material.materialName} ({material.quantity})
            </li>
          ))}
        </ul>
      ),
    },
    {
      title: "Продукции",
      key: "produces",
      render: (_: any, record: Changelog) => (
        <ul>
          {record.produces.map((produce) => (
            <li key={produce.produceId}>
              {produce.produceName} ({produce.quantity})
            </li>
          ))}
        </ul>
      ),
    },
  ];
  return (
    <div style={{ padding: 24 }}>
      <Title level={2}>Журнал {name}</Title>
      <Space style={{ marginBottom: 16 }}>
        <RangePicker
          onChange={handleRangeChange}
          placeholder={["Начало", "Конец"]}
          format="DD.MM.YY"
          value={dateRange}
        />
      </Space>
      <Table
        loading={loading}
        columns={columns}
        dataSource={changelogs}
        rowKey={(record) => record._id}
        pagination={{
          current: page,
          total: total,
          pageSize: pageSize,
          onChange: (page, size) => {
            setPage(page);
            if (size !== pageSize) setPageSize(size!);
          },
        }}
        scroll={{ x: "max-content" }}
      />
    </div>
  );
}
